import { type JSX } from 'react';
import {
  HeadlessAppletCapability,
  type Specs,
} from '@doxyme/extensions-bridge';
import {
  AppletFrame,
  useAddCapability,
  useBasicObservable,
} from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type Applet = Specs.HeadlessApplet.Applet;

/**
 * The HeadlessAppletCapability needs a place that it can render into.
 * This component is responsible for rendering headless frame applets.
 */
export function ExtensionsHeadless(): JSX.Element {
  const headlessApplet = useAddCapability(
    bridge,
    () => new HeadlessAppletCapability(),
  );

  const [applets] = useBasicObservable<Applet[]>(headlessApplet.getFrames());

  return (
    <div style={{ display: 'none' }}>
      {applets.map((applet) => (
        <AppletFrame key={applet.runtimeId} applet={applet.frame} />
      ))}
    </div>
  );
}
